<template>
  <v-card dark v-if="selectedEmail">
    <v-card-title>
      {{ selectedEmail.subject }}
    </v-card-title>
    <v-card-subtitle>
      From: {{ selectedEmail.from }} | To: {{ selectedEmail.to }} | Date: {{ formatDate(selectedEmail.date) }}
      <div v-if="selectedEmail.category || selectedEmail.studio">
        Category: {{ selectedEmail.category }} | Studio: {{ selectedEmail.studio.name }}
      </div>
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <div v-html="selectedEmail.body"></div>
    </v-card-text>
    <v-card-actions>
      <v-btn icon @click="reply">
        <v-icon>mdi-reply</v-icon>
      </v-btn>
      <v-btn icon @click="forward">
        <v-icon>mdi-share</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <CategoryManager />
      <v-btn icon @click="$store.dispatch('mailStore/selectEmail', null)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <ComposeMail v-model="showCompose" :reply-to="selectedEmail" :forward="isForward" />
  </v-card>
  <v-card v-else class="d-flex justify-center align-center h-100">
    <v-card-text class="text-center"> Select an email to read </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"
import moment from "moment"
import CategoryManager from "./CategoryManager.vue"
import ComposeMail from "./ComposeMail.vue"

export default {
  name: "EmailView",
  components: {
    CategoryManager,
    ComposeMail,
  },
  data: () => ({
    showCompose: false,
    isForward: false,
  }),
  computed: {
    ...mapGetters("mailStore", ["selectedEmail"]),
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm")
    },
    reply() {
      this.isForward = false
      this.showCompose = true
    },
    forward() {
      this.isForward = true
      this.showCompose = true
    },
  },
}
</script>

<style scoped>
.v-card {
  background-color: transparent !important;
  color: #ffffff !important;
  height: 100%;
}

.v-card-title {
  font-size: 1.5rem;
  font-weight: 500;
}

.v-card-subtitle {
  color: #b0b0b0 !important;
}

.v-card-text {
  color: #ffffff !important;
}
</style>